import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '../../../custom-function.service';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
	selector: 'app-underwritingagencyexception',
	templateUrl: './underwritingagencyexception.component.html',
	styleUrls: ['./underwritingagencyexception.component.scss'],
})
export class UnderwritingagencyexceptionComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();
	agencyName: string;
	agencyIssuedArray: string[] = [];

	countAgencyMonth: number;
	totalAgencyfundedMonth: any;

	constructor(
		private apiService: LegacyApiService,
		private customFunction: CustomFunctionService,
		private router: ActivatedRoute,
		private _routerLink: Router,
		private store: Store<State>
	) {}

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					// Get the collector name from the nlsAgencyFunded page
					this.router.queryParams.subscribe((params) => {
						this.agencyName = params['agency'];
					});

					this.apiService
						.getDealsCreatedUnderwritingException()
						.subscribe((res) => {
							let arr = JSON.parse(res.message.body);
							this.agencyIssuedArray = this.customFunction.singleFilterName(
								arr.data,
								'Agency_Formula',
								this.agencyName
							);
							this.customFunction.sortColumn(
								this.agencyIssuedArray,
								'Exception_Funded_Amount',
								-1,
								1
							);

							this.countAgencyMonth = this.agencyIssuedArray.length;
							this.totalAgencyfundedMonth = this.customFunction.sumNumbers(
								this.agencyIssuedArray,
								'Exception_Funded_Amount'
							);
						});
				}
			});
	}

	ngOnDestroy() {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
